import {DataEventContext} from '../../libs/shared/core/src/models/tracking/dataEventContexts';

export const appTrackingContext: DataEventContext = Object.freeze({name: 'app', payload: {}});
